import { useState } from "react";
import { SpinnerLegacy } from "../../../components";
import { RouteTabbedList } from "../../../components/navigationTabs/RouteTabbedList";
import { useSupplierOrderList } from "../../../hooks/api/v2/order/useSupplierOrderList";
import { SupplierAllOrdersList } from "./AllOrders/SupplierAllOrdersList";
import { SupplierRequestedOrderList } from "./RequestedOrders/SupplierRequestedOrderList";
import { OrdersListMenu } from "./AllOrders/AllOrdersList";
import { useOrderListTabSelection } from "./useOrderListTabSelection";

export const SupplierOrdersListTabs = ({
  selectedOrderId,
}: {
  selectedOrderId: number | null;
}) => {
  // Same query as in orderRequested tab - used to say whther to set initial tab
  // as all orders or requested orders
  const query = useSupplierOrderList({
    limit: 20,
    query: [
      {
        type: "acceptedAt",
        modifier: "IS_NULL",
      },
      {
        type: "cancelledAt",
        modifier: "IS_NULL",
      },
      {
        type: "deniedAt",
        modifier: "IS_NULL",
      },
    ],
  });

  if (query.isPending) return <SpinnerLegacy />;

  return (
    <SupplierOrderListTabs
      acceptedOrdersLength={query.data?.pages[0]?.length ?? 0}
      selectedOrderId={selectedOrderId}
    />
  );
};

const SupplierOrderListTabs = ({
  acceptedOrdersLength,
  selectedOrderId,
}: {
  acceptedOrdersLength: number;
  selectedOrderId: number | null;
}) => {
  const acceptedOrdersCount =
    acceptedOrdersLength >= 10 ? "10+" : acceptedOrdersLength.toString();
  const hasAcceptedOrders = !!acceptedOrdersLength;
  const [defaultTab] = useState(
    hasAcceptedOrders ? "Order requests" : "All orders",
  );
  const { getTabUrl, selectedTabName } = useOrderListTabSelection({
    attentionTabName: "Order requests",
    defaultTab,
    enabled: true,
  });

  return (
    <RouteTabbedList
      ariaLabel="Order views"
      headerContent={
        selectedTabName === "All orders" ? <OrdersListMenu /> : null
      }
      selectedTab={selectedTabName}
      tabs={[
        {
          label: `Order requests (${acceptedOrdersCount})`,
          name: "Order requests",
          panel: (
            <SupplierRequestedOrderList selectedOrderId={selectedOrderId} />
          ),
          to: getTabUrl("Order requests"),
        },
        {
          label: "All orders",
          name: "All orders",
          panel: <SupplierAllOrdersList selectedOrderId={selectedOrderId} />,
          to: getTabUrl("All orders"),
        },
      ]}
    />
  );
};
